export const API_ENDPOINTS = {
  BRAND: '/mBrand',

  VERSION:'/ChangeVersion',
  SAZMAN: '/Sazman',
  SAZMAN_GetPublicSazman: '/Sazman/GetPublicSazman',

  DATASOURCE: '/DataSource',
  DATASOURCE_FULL: '/DataSource/FullGet',
  DATASOURCE_CheckCountDatasource: '/DataSource/CheckCountDatasource',  
  DATASOURCE_CREATE: '/DataSource/Create2',
  DATASOURCE_CREATEGOOGLESHEET: '/DataSource/GoogleSheet',
  DATASOURCE_CreateSql: '/DataSource/CreateSql',
  DATASOURCE_CreateElastic: '/DataSource/CreateElastic',
  DATASOURCE_Webservice: '/DataSource/Webservice',  
  DATASOURCE_CreateOracle: '/DataSource/CreateOracle',
  DATASOURCE_CreateMySql: '/DataSource/CreateMySql',    
  DATASOURCE_DATAMODEL: '/DataSource/DataModel',
  DATASOURCE_UPDATE: '/DataSource/Update2',
  DATASOURCE_DELETE: '/DataSource/Delete2',
  DATASOURCE_FULLGET:'/DataSource/FullGet',
  DATASOURCEExcel: '/DataSource/UploadExcel',
  DATASOURCECSV: '/DataSource/UploadCsv',
  DATASOURCEConnectioTest: '/DataSource/GetConnectionTest',
  DATASOURCEConnectioExcelTest: '/DataSource/ConnectionTestDataSourceExcel',
  DATASOURCEConnectioCsvTest: '/DataSource/ConnectionTestDataSourceCsv',
  DATASOURCEGetSheetExcel: '/DataSource/RetSheetExcel',
  DATASOURCERetSheetWebservice: '/DataSource/RetSheetWebservice',
  DATASOURCETestConnectionFromSite: '/DataSource/TestConnectionFromSite',   
  DATASOURCEGetSheetGooglesheet: '/DataSource/RetSheetGooglesheet',
  DATASOURCEConnectioGooglesheetTest: '/DataSource/ConnectionTestDataSourceGoogleSheet',
  DATASOURCEConnectioWebserviceTest: '/DataSource/ConnectioWebserviceTest',

  DATASOURCE_ManageSecurity: '/DataSource/ManageSecurity',
  DATASOURCE_NEWBACKUP: '/DataSource/NewBackup',  
  DATASOURCE_RetFilesBackup: '/DataSource/RetFilesBackup',
  DATASOURCE_UpgradeDatasource: '/DataSource/UpgradeDatasource',
  DATASOURCE_EXECUTESQLQUERY: '/DataSource/ExecuteSqlQuery',
  Multimedia_Image: '/Multimedia/DownLoadMultimedia',  

  GVariable: '/GlobalVariable',
  
  BACKUP:'/backup',
  BACKUP_Delete2:'/backup/Delete2',
  BACKUP_AddBackup:'/backup/AddBackup',
  BACKUP_AddScheduleBackup:'/backup/AddScheduleBackup',
  BACKUP_EditScheduleBackup:'/backup/EditScheduleBackup',  
  BACKUP_GetDescriptionSchedule:'/backup/GetDescriptionSchedule',

  

  Users: '/Users',
  Users_GetUserVariables: '/Users/GetUserVariables',
  Users_Permissions: '/Users/ManagePermissions',
  Users_Permissions_Menu: '/Users/ManagePermissionsUserMenu',
  Users_Permissions_Chart: '/Users/ManagePermissionsUserChart',
  Users_ManageUserSecurity: '/Users/ManageUserSecurity',
  UserRoleTree: '/Users/tree',
  ChangeUserActive: '/Users/ChangeUserActive',
  ChangeUserPass: '/Users/changePassword',  
  GenerateTokenResetPassword: '/Users/GenerateTokenResetPassword',
  ResetPassword: '/Users/ResetPassword',
  UserSecurity: '/UserSecurity',
  CurrentUserSecurity: '/UserSecurity/GetSecurityUser',
  RoleSecurity: '/RoleSecurity',  


  Roles: '/Roles',
  Roles_Permissions: '/Roles/ManagePermissions',
  Roles_Permissions_Menu: '/Roles/ManagePermissionsRoleMenu',
  Roles_Permissions_Chart: '/Roles/ManagePermissionsRoleChart',
  GetUserInRole: '/Roles/GetUserInRole',  


  Roles_ManageRoleSecurity: '/Roles/ManageRoleSecurity',

  ColorPallet: '/ColorPallet',

  Form: '/Form',
  Form_FullGet: '/Form/FullGet',
  FORM_CREATE3: '/Form/Create3',
  FORM_UPDATE3: '/Form/Update3',
  FORM_DELETE: '/Form/Delete2',
  FORM_CopyForm: '/Form/CopyForm',
  FORM_PAGE: '/Form/page',
  FORM_SUBFORM: '/Form/subform',

  FORM_DATAALLFIELDFORM: '/Form/DataAllFieldForm',
  FORM_DATAALLFIELDDATASOURCE: '/Form/DataAllFieldDatasource',   
  FORM_GET: '/Form/myGet',
  FORM_SUBMIT:'/Form/submit',
  FORM_SUBMIT_DELETE:'/Form/submitDelete',
  FORM_SUBMIT_COPY: '/Form/submitCopy',

  CHART: '/Chart',
  CHART_FULLGET:'/Chart/FullGet',
  CHART_CREATE: '/Chart/Create2',
  CHART_CREATE3: '/Chart/Create3',
  CHART_UPDATE3: '/Chart/Update3',
  CHART_DELETE: '/Chart/Delete2',
  CHART_TREE: '/Chart/tree',
  CHART_DATASOURCE: '/Chart/ChartDatasource',
  CHART_CheckCountChart:'/Chart/CheckCountChart',

  WORKFLOW: '/Workflows',
  WORKFLOW_CONVERT_XMTTOJSON: '/Workflows/xmlTojson',
  
  Notification: '/Notifications',  
  Notification_Get: '/Notifications/GetNotification',
  Notification_unreadcount: '/Notifications/unreadcount',
  Notification_markread: '/Notifications/markread',
  Notification_markallread: '/Notifications/markallread',
  Notification_TEST: '/Notifications/test/send',

  CHARTCOMMENTS: '/ChartComments',
  CHARTCOMMENTS_GET: '/ChartComments/GetChartComments',
  CHARTCOMMENTS_CREATE: '/ChartComments/Create2',
  

  CUBE_GET_DATATABLEFROMDATASOURCE: '/Cube/GetDataTableFromQuery',
  CUBE_GET_QUERY: '/Cube',
  CUBE_GET_FILTERQUERY: '/Cube/CubeFilter',
  CUBE_GET_FILTERQUERY_DASH: '/Cube/CubeFilterDash',
    
  CUBE_POSTEXPORTEXCEL: '/Cube/postExportExcel',

  RADIO: '/Radio',
  RADIO_GROUPID: '/Radio/GroupId',
  RADIO_TREE: '/Radio/tree',
  RADIO_TREEWITHGROUP: '/Radio/treeWithGroup',
  RADIO_MasterRadio: '/Radio/MasterRadio',
  

  

  MENU: '/MenuPage',
  MENU_ID: '/MenuPage',
  MENU_SECURITY: '/MenuPage/MenuSecurity',  
  MENU_GROUPID: '/Radio/GroupId',
  MENU_TREE: '/MenuPage/tree',
  MENU_TREE_FORM: '/MenuPage/treeForm',
  MENU_FULLTREE: '/MenuPage/Fulltree',
  MENU_TREEMENU: '/MenuPage/treeMenu',
  MENU_TREEWITHCHART: '/MenuPage/treeWithChart',
  MENU_CheckCountMenu: '/MenuPage/CheckCountMenu',    
  
  FILTERMENU: '/FilterMenuPage',
  FILTERMENU_PAGE: '/FilterMenuPage/page',  

  CHARTMENUPAGE: '/ChartMenuPage',
  CHARTMENUPAGE_PAGE: '/ChartMenuPage/page',
  CHARTMENUPAGE_DELETECHARTFROMPAGE: '/ChartMenuPage/deleteChartFromPage',
  CHARTMENUPAGE_UPDATECHARTFROMPAGE: '/ChartMenuPage/updateChartFromPage',
  CHARTMENUPAGE_UPDATECHARTISVIEW: '/ChartMenuPage/updateChartIsView',
  CHARTMENUPAGE_LANDING: '/ChartMenuPage/landing',

  CHARTMENUPAGEUSER_RESETJANAMAEI: '/ChartMenuPageUser/resetJanamaei',
  
  SHARELINK:'/ShareLink',
  SHARELINK_PAGE: '/ShareLink/page',
  SHARELINK_MENUPAGE: '/ShareLink/PublicMenuPage',
  SHARELINK_PAGEINFO: '/ShareLink/PublicPageInfo',
  SHARELINK_GENENPUBLICPAGE: '/ShareLink/GenEnPublicPageInfo',
  SHARELINK_CHANGEACTIVE: '/ShareLink/ChangeActive',
  SHARELINK_SHARELOGIN: '/ShareLink/shareLogin',
  SHARELINK_CHANGELOGIN: '/ShareLink/ChangeLogin',

    WORKfLOW:'/sWorkFlow',
  TASKWORKfLOW:'/sWorkFlow/task',
  ALLTASKWORKfLOW:'/sWorkFlow/allTask',
  WORKfLOW_CREATE:'/sWorkFlow/createXml',
  NEXTSTEP:'sWorkFlow/run',
  resume:'sWorkFlow/resume',
  WORKFLOWUPDATE:'sWorkFlow/update3',


  PAGE: '/Page',

  PERMISSION: '/Permission',
  PERMISSION_TREE: '/Permission/tree',

  LICENCE:'/License',
  LICENCE_SERVERUNIQUECODE: '/License/serverUniqueCode',
  LICENCE_ACTIVECODE: '/License/activeCode',
  LICENCE_CountDatasource: '/License/CountDatasource',



};

export const KEY_ENDPOINTS = {
  BRAND_LIST: 'BrandList',

  RADIO_LIST: '/RadioList',
  RADIO_GROUPID: '/Radio/GroupId',
  RADIO_TREE_LIST: ''
};
